import { useState } from 'react';
import AppManager from 'src/commun/AppManager';
import { ComplexInput } from 'src/commun/component/ComplexInput';
import BasePrice from 'src/object/BasePrice';
import { post } from '../../commun/HTTP';
import Budget from '../../object/Budget';

export interface IQuantityProps {
    budget: Budget;
    basePrice: BasePrice;
}

export const PriceInput = (props: IQuantityProps) => {
    const { budget, basePrice } = props;

    const [val, setVal] = useState(budget.price.get());

    return (
        <ComplexInput
            disabled={budget.bon_commande.get() !== null || !basePrice.canAct()}
            value={val + ''}
            onBlur={() => {
                budget.leaveFocus();
                budget.addEdit({
                    quantity: isNaN(budget.quantity.get()) ? '' : budget.quantity.get(),
                });
            }}
            onFocus={() => {
                budget.getFocus();
            }}
            typeValue="eur"
            setValue={(e) => {
                budget.price.set(parseFloat(e));
                budget.addEdit({
                    price: isNaN(budget.price.get()) ? '' : budget.price.get(),
                });
                setVal(e);
                AppManager.makeUpdate();
            }}
            placeholder="Prix"
            className="bg-gray-300 w-32 placeholder:text-gray-600 border-gray-400 border rounded-lg py-2 px-3 focus:!border focus:!ring focus:!ring-blue-500 focus:!border-blue-500"
        />
    );
};
